// Full updated Clients.tsx with clean pagination control via dataState only

import React, { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { Button } from "@progress/kendo-react-buttons";
import { HandleGridBody } from "components/common/HandleGridBody.js";
import AddClients from "./AddViewClients.jsx";
import { useNavigate } from "react-router-dom";
import SearchTextBox from "../../components/SearchComponent.jsx";
import { getClientDropDownData } from "actions/common.action.js";
import { FilterComponent } from "components/common/FiltersComponent";
import {
    changeClientEditPermission,
    getClientsList,
} from "../../actions/clients.action.js";
import { RedirectCell } from "components/common/GridComponents.jsx";
import { arrowRotateCwIcon as refreshIcon } from "@progress/kendo-svg-icons";
import { SvgIcon } from "@progress/kendo-react-common";
import { Skeleton } from "@progress/kendo-react-indicators";
import { getClientData } from "api";
import MattersGridComponent from "../../components/Matters/MattersGridComponent.jsx";
import LoadingScreen from "components/common/Loading.js";
import styles from "./Clients.module.scss";
import {
    updateCurrentUserSettings,
    useCurrentUserSettings,
} from "services/userSettingsService.js";
import {
    getAccessRightsData,
    useCurrentUser,
} from "services/currentUserService.js";
import MatterForm from "pages/Matters/MatterForm";
import addMatter from "../../assets/add-matter.png";
import { GridLoader } from "components/GridLoader.jsx";
import { useCompany } from "services/companyService.js";

const USER_SETTING_PAGE_SIZE_KEY = "ClientListPageSize";

const DetailComponent = (props) => {
    const data = props.dataItem.matters;
    const matters = data?.filter((matter) => !matter.closed);
    return data?.length > 0 ? (
        <MattersGridComponent Clientdata={matters} fromClient={true} />
    ) : (
        <div className="text-center fw-semibold">No matters found</div>
    );
};

const Clients = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { data: userSettings } = useCurrentUserSettings();
    const { data: currentUser } = useCurrentUser();
    const { data: company } = useCompany();

    const [dataState, setDataState] = useState({
        take:
            Number(
                userSettings?.find((s) => s.key === USER_SETTING_PAGE_SIZE_KEY)?.value
            ) || 50,
        skip: 0,
        sort: [{ field: "clientRef", dir: "asc" }],
        pageable: {
            pageSizes: [25, 50, 100, 200],
        },
    });
    const [list, setLists] = useState({ data: [], total: 50 });
    const [eventDataState, setEventDataState] = useState();
    const [filterParameters, setFilterParameters] = useState({
        feeEarnerRef: currentUser?.userRef,
    });
    const [showClientForm, setShowClientForm] = useState(false);
    const [showClientView, setshowClientView] = useState(false);
    const [editData, setEditData] = useState({});
    const [isView, setIsView] = useState(false);
    const [isRefreshed, setIsRefreshed] = useState(false);
    const [searchValue, setSearchValue] = useState();
    const [isSearched, setIsSearched] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [loadedContent, setLoadedContent] = useState(true);
    const [allowAccessData, setAllowAccessData] = useState({});
    const [reference, setReference] = useState("");
    const [clientId, setClientId] = useState("");
    const [showMatterForm, setShowMatterForm] = useState(false);
    const [matterFormClient, setMatterFormClient] = useState(null);

    const viewEdit = useSelector((state) => state.clients.clinetEditPermission);
    const searchRef = useRef();

    useEffect(() => {
        const saved = Number(
            userSettings?.find((s) => s.key === USER_SETTING_PAGE_SIZE_KEY)?.value
        );
        if (saved && saved !== dataState.take) {
            setDataState((prev) => ({ ...prev, take: saved, skip: 0 }));
        }
    }, [userSettings]);

    const dataStateChange = async (e) => {
        const newPageSize = e.dataState.take;
        const currentPageSize = dataState.take;

        const updatedDataState = {
            ...e.dataState,
            skip: newPageSize !== currentPageSize ? 0 : e.dataState.skip,
            pageable: dataState.pageable, // Forcefully re-apply pageable
        };

        if (newPageSize !== currentPageSize) {
            try {
                await updateCurrentUserSettings([
                    { key: USER_SETTING_PAGE_SIZE_KEY, value: newPageSize },
                ]);
            } catch (err) {
                console.error("Failed to update page size", err);
            }
        }

        setDataState(updatedDataState);
        setEventDataState({ event: updatedDataState });
    };
    const handleRefresh = () => {
        setIsSearched(false);
        setIsRefreshed(!isRefreshed);
        const resetState = eventDataState
            ? { ...eventDataState.event, skip: 0 }
            : { ...dataState, skip: 0 };
        setDataState(resetState);
    };

    const getAccessRights = async () => {
        try {
            const data = await getAccessRightsData();
            setAllowAccessData(data?.data?.data);
            setLoadedContent(false);
        } catch { }
    };

    useEffect(() => {
        dispatch(getClientDropDownData());
        getAccessRights();
    }, []);

    const dataReceived = (list) => list?.data && setLists(list);

    const analyzeFilterParamters = (params) => {
        setFilterParameters({
            branch: params?.branch,
            appCode: params?.appCode,
            feeEarnerRef: params?.feeEarnerRef,
            teamId: params?.teamId,
        });
    };

    const onClientRefClickActions = (props) => {
        setReference(props.dataItem?.clientRef);
        clientsDataGetter(props.dataItem?.clientId);
        setClientId(props.dataItem?.clientId);
        setshowClientView(true);
    };

    const clientsDataGetter = async (id) => {
        try {
            setIsLoading(true);
            const data = await getClientData(id);
            setEditData(data?.data?.data);
            setIsLoading(false);
        } catch {
            setIsLoading(false);
            alert("No client exists against this Id. Try again with different Id");
            navigate("/clients");
        }
    };

    const ClientCell = (props) => (
        <td>
            <u
                style={{ cursor: "pointer" }}
                onClick={() => onClientRefClickActions(props)}
            >
                {props.dataItem.clientRef}
            </u>
        </td>
    );

    const NoOfMattersCell = (props) => (
        <td className="text-center">
            {props.dataItem.noOfMatters > 0 && props.dataItem.noOfMatters}
        </td>
    );

    const Redirect = (props) => (
        <RedirectCell handleClick={() => onClientRefClickActions(props)} />
    );

    const getHeaderItems = () =>
        loadedContent ? (
            <Skeleton
                shape="rectangle"
                className="mb-3"
                style={{ width: "100%", height: "70px" }}
            />
        ) : (
            <div className="d-flex align-items-end mb-3">
                <FilterComponent
                    allowAccessData={allowAccessData}
                    updateFilters={analyzeFilterParamters}
                    isRefreshed={isRefreshed}
                />
                <SearchTextBox
                    ref={searchRef}
                    changeFilterValue={(e) => {
                        setIsSearched(true);
                        setSearchValue(e);
                    }}
                />
                <Button
                    className="ms-2 common-btn me-1"
                    onClick={handleRefresh}
                    style={{ minWidth: "20px" }}
                >
                    <span className="d-flex align-items-center">
                        <SvgIcon icon={refreshIcon} />
                        <span className="d-xxl-inline-block d-sm-none ms-1">Refresh</span>
                    </span>
                </Button>
                <Button
                    className="common-btn ms-auto me-2"
                    onClick={() => {
                        setShowClientForm(true);
                        setIsView(false);
                        setEditData("");
                    }}
                >
                    Add Client
                </Button>
                {company?.modules?.ClientOnboarding && (
                    <Button
                        className="common-btn text-wrap"
                        onClick={() => navigate(`/clients/onboarding`)}
                    >
                        Client Onboarding
                    </Button>
                )}
            </div>
        );

    const AddMatterCell = (props) => {
        return (
            <td className="text-center cursor-pointer">
                <img
                    src={addMatter}
                    alt="Add Matter"
                    title="Add Matter"
                    width={18}
                    height={18}
                    onClick={() => {
                        setMatterFormClient(props.dataItem);
                        setShowMatterForm(true);
                    }}
                />
            </td>
        );
    };

    return (
        <div className="page h-100 w-100 d-flex flex-column">
            {getHeaderItems()}
            <Grid
                {...dataState}
                data={list}
                detail={DetailComponent}
                expandField="expanded"
                onExpandChange={(e) => {
                    e.dataItem.expanded = e.value;
                    setLists({ data: [...list.data], total: list.total });
                }}
                onDataStateChange={dataStateChange}
                sortable
                resizable
                className={`fs-md flex-grow-1 overflow-auto ${styles["clientname-min-width"]}`}
                showLoader={isLoading}
                loader={<GridLoader />}
            >
                <GridNoRecords>
                    {isLoading ? (
                        <div style={{ height: "110px" }}></div>
                    ) : (
                        list.data && list.data.length === 0 && "No records available"
                    )}
                </GridNoRecords>
                <GridColumn
                    field="clientRef"
                    title="Client Ref"
                    cell={ClientCell}
                    width="120px"
                />
                <GridColumn
                    field="clientName"
                    title="Client Name"
                    className="gridBoldField text-wrap"
                />
                <GridColumn field="feeEarnerRef" title="Fee Earner" width="103px" />
                <GridColumn field="type" title="Type" width="120px" />
                <GridColumn field="phoneNo" title="Phone" width="150px" />
                <GridColumn field="email" title="Email" width="220px" />
                <GridColumn
                    field="address"
                    title="Address"
                    className="text-wrap"
                    width="220px"
                />
                <GridColumn
                    field="noOfMatters"
                    title="Matters"
                    width="100px"
                    cell={NoOfMattersCell}
                />
                <GridColumn width="45px" cell={AddMatterCell} />

                <GridColumn width="60px" cell={Redirect} />
            </Grid>
            {userSettings && (
                <HandleGridBody
                    dataState={dataState}
                    onDataReceived={dataReceived}
                    searchValue={isSearched ? searchValue : null}
                    isSearched={isSearched}
                    isRefreshed={isRefreshed}
                    currentComponent="clients"
                    filterParameters={filterParameters}
                    setIsLoading={setIsLoading}
                    showLoader={false}
                />
            )}

            {(showClientForm || viewEdit) && (
                <Dialog
                    className="dialog-xxl add-dialog"
                    title={viewEdit ? "Update Client" : "Add Client"}
                    onClose={() => {
                        if (viewEdit) dispatch(changeClientEditPermission());
                        setShowClientForm(false);
                    }}
                >
                    <AddClients
                        data={editData}
                        isView={isView}
                        formId={viewEdit ? "edit" : "add"}
                        title="Add Client"
                        onClose={() => {
                            if (viewEdit) dispatch(changeClientEditPermission());
                            setShowClientForm(false);
                            clientsDataGetter(clientId);
                            dispatch(
                                getClientsList(
                                    dataState.skip / dataState.take + 1,
                                    dataState.take
                                )
                            );
                        }}
                    />
                    <DialogActionsBar>
                        <div className="dialog-footer">
                            <Button
                                className="common-btn bgBtnSecondary border-0 me-2"
                                onClick={() => {
                                    if (viewEdit) dispatch(changeClientEditPermission());
                                    setShowClientForm(false);
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                className="common-btn me-4"
                                type="submit"
                                onClick={() =>
                                    document.getElementById("client-submitter").click()
                                }
                            >
                                {viewEdit ? "Update Client" : "Add Client"}
                            </Button>
                        </div>
                    </DialogActionsBar>
                </Dialog>
            )}

            {showClientView && !isLoading && (
                <AddClients
                    data={editData}
                    formId="view"
                    onClose={() => setshowClientView(false)}
                    reference={reference}
                    type="VIEW"
                />
            )}
            {showMatterForm && (
                <MatterForm
                    setshowMatterForm={() => {
                        setShowMatterForm(false);
                        setMatterFormClient(null);
                    }}
                    clientData={matterFormClient}
                />
            )}
        </div>
    );
};

export default Clients;
